import { User } from "../../../domain/user";
import { Patient } from "../../../domain/patient";
import { Department } from "../../department";

export class ClaioSchemaExecuteRequest {
  user: User;
  patient: Patient;
  department: Department;
  originalImageSourceUrl: string;
  currentImageSourceUrl: string;
  drawLayerImageSourceUrl: string;
  drawObjectData: string;
}
